import React, { useState, useEffect, useRef } from 'react';
import { flushSync } from 'react-dom';
import {
  Row, Col, Typography, Card, Form, Button, message,
  Input,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import { getUserMail, getUserType } from '../../../../../utils/users';
import SelectedLands from '../../../serviceComponents/selectedLands/SelectedLands';
import GeoMapSummary from '../../../serviceComponents/geoMapSummary/GeoMapSummary';
import AreaTalhao from '../../../../sharedComponents/talhao/AreaTalhao';
import UploadFiles from '../../../serviceComponents/uploadFiles/UploadFiles';
import { SessionExpiredException } from '../../../../../utils/errors';
import { isItEstimateOrService } from '../../../../../utils/service';
import {
  post, get, isSuperAgentError,
  RequestWrapper, ResponseWrapper,
} from '../../../../../dataSource/requests';
import './Summary.scss';

const Summary = (props) => {
  const [formInstance] = Form.useForm();
  const navigate = useNavigate();

  const uploadFilesReference = useRef(null);
  const [valueAttachmentSizeCooperated, setValueAttachmentSizeCooperated] = useState(null);

  const [loading, setLoading] = useState(false);
  const [requestId, setRequestId] = useState(null);

  const {
    removeSelectedField, serviceRequestParameters, nextPage, previousPage,
  } = props;

  const getLabel = (value) => {
    switch (value) {
      case 'VANT-MAPEAMENTO_ERVAS-INVASORAS-INSERIR_ALTURA_CULTURA':
        return 'Inserir a altura da cultura (em m)';

      case 'VANT-MAPEAMENTO_ERVAS-INVASORAS-PULVERIZACAO':
        return 'Pulverização';

      case 'VANT-MAPEAMENTO_ERVAS-INVASORAS-SUBSOLAGEM':
        return 'Subsolagem';

      case 'VANT-MAPEAMENTO_ERVAS-INVASORAS-GRADAGEM':
        return 'Gradagem';

      case 'VANT-MAPEAMENTO_ERVAS-INVASORAS-CULTURA_SECUNDARIA':
        return 'Cultura Secundária';

      case 'VANT-MAPEAMENTO_ERVAS-INVASORAS-CULTURA_TERCEARIA':
        return 'Cultura Terciária';

      case 'VANT-MAPEAMENTO_ERVAS-INVASORAS-AUTOMATIZACAO_MANOBRA_PLANTIO':
        return 'Automatização de Manobra de Plantio (cereais)';

      default:
        return `${value}`;
    }
  };

  const printValue = (value) => {
    switch (true) {
      case value === true:
      case value === 'true':
        return 'Sim';

      case value === false:
      case value === 'false':
        return 'Não';

      case (value?._isAMomentObject):
        return value.format('DD/MM/YYYY');

      case (/[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}Z/.test(value)):
        return moment(value, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]').format('DD/MM/YYYY');

      default:
        return value;
    }
  };

  const getField = (idCodeParameter) => {
    return serviceRequestParameters
      .serviceTypeDynamicFields
      .find(
        (field) => {
          return field.idCode === idCodeParameter;
        },
      );
  };

  const renderField = (idCodeParameter) => {
    const field = getField(idCodeParameter);

    if (field !== undefined) {
      return (
        <Row
          className="VantMapErvasInvasorasSummary__DetailRow"
        >
          <Col
            span={24}
            className="VantMapErvasInvasorasSummary__DetailParentColumn"
          >
            <Row
              justify="space-between"
              className="VantMapErvasInvasorasSummary__DetailChildRow"
            >
              <Col
                className="VantMapErvasInvasorasSummary__DetailColumn"
              >
                {getLabel(idCodeParameter)}
              </Col>
              <Col
                className="VantMapErvasInvasorasSummary__DetailSpecificColumn"
              >
                {printValue(field.value)}
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }

    return null;
  };

  const mask = (rawValue) => {
    if (rawValue.length > 14) {
      return [
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ];
    }
    return [
      '(',
      /[1-9]/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  };

  const getAttachmentParamenters = async () => {
    try {
      const requestRef: RequestWrapper = get({
        url: '/system/getAttachmentParamenters',

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      const response = await requestRef;

      setValueAttachmentSizeCooperated(
        response?.body.getAttachmentParamentersOutput.attachmentSizeCooperated,
      );
    } catch (error) {
      message.error('Ocorreu um erro ao buscar informações, tente novamente');
    }
  };

  useEffect(() => {
    getAttachmentParamenters();
    return () => {
      setLoading(false);
    };
  }, []);

  const userMailCooperative = () => {
    const targetMail = getUserMail() ? getUserMail().replaceAll('"', '') : '-';

    return (
      <div>
        <div>
          <span>{`Email: ${getUserType() === 'COOPERATIVE' ? targetMail : '-'}`}</span>
        </div>
        <div>
          <span style={{ fontSize: '.7rem' }}>(caso esteja incorreto, informar e-mail válido no campo observação)</span>
        </div>
      </div>
    );
  };

  const onFormFinish = async (values) => {
    setLoading(true);
    let response;

    let telValue = values.TelInput;
    telValue = !telValue ? '' : telValue.replace(/\D/g, '');

    const data = {
      landFieldsIds: serviceRequestParameters.talhoesSelecionados.map((v) => v.id),
      landId: serviceRequestParameters.selectedProperty.id,
      landOwnerId: serviceRequestParameters.selectedOwner.id,
      serviceId: serviceRequestParameters.selectedService.id,
      cooperativeNotes: values.observacao,
      telephone: telValue,
      serviceTypeId: serviceRequestParameters.selectedType.id,
      haveCtc: serviceRequestParameters.haveCtc,
      ctc: serviceRequestParameters.ctc,
      branchCoopercitrusId: serviceRequestParameters.branchCoopercitrusId,
      serviceTypeDynamicFields: serviceRequestParameters.serviceTypeDynamicFields,
    };

    let targetUrl = '';
    if (serviceRequestParameters.choiceServiceType === 1) {
      targetUrl = '/budget/requestBudgetService';
    } else {
      targetUrl = '/service/requestService';
    }

    try {
      const requestRef: RequestWrapper = post({
        url: targetUrl,
        params: data,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await requestRef;
    } catch (error) {
      if (!(error instanceof SessionExpiredException)) {
        message.error('Ocorreu um erro ao solicitar o serviço, tente novamente');
      }
      setLoading(false);
      return;
    }

    if (!response?.body.error) {
      if (response?.body.code === 5002) {
        flushSync(() => {
          setRequestId(response?.body.createServiceRequestOutput.serviceRequestId);
        });
      } else {
        flushSync(() => {
          setRequestId(response?.body.createBudgetOutput.budgetId);
        });
      }

      const uploadError = !uploadFilesReference.current.validateFiles();
      if (!uploadError) {
        try {
          await uploadFilesReference.current.handleSubmitFiles();
        } catch (error) {
          setLoading(false);
          return;
        }

        nextPage({});
      }
    } else if (response?.body.code === -6006) {
      message.error('Esta cultura não é válida para este serviço');
    } else {
      message.error('Ocorreu um erro ao solicitar o serviço, tente novamente');
    }

    setLoading(false);
  };

  return (
    <div className="VantMapErvasInvasorasSummary">
      <Row
        justify="space-between"
        className="VantMapErvasInvasorasSummary__TitleRow"
      >
        <Col
          className="VantMapErvasInvasorasSummary__TitleCol"
        >
          <Typography.Title
            level={1}
            className="VantMapErvasInvasorasSummary__Title"
          >
            Resumo da Solicitação
          </Typography.Title>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="VantMapErvasInvasorasSummary__ContentRow"
      >
        <Col
          span={24}
          className="VantMapErvasInvasorasSummary__ContentColumn"
        >
          <Card
            className="VantMapErvasInvasorasSummary__ContentCard"
          >
            <Form
              scrollToFirstError
              className="VantMapErvasInvasorasSummary__Form"
              form={formInstance}
              onFinish={onFormFinish}
              layout="vertical"
              onFinishFailed={
                (errorInfo) => {
                  console.log('vant MapErvasInvasoras summary form finish failed:', errorInfo);
                }
              }
            >
              <Row
                gutter={[24, 24]}
                className="VantMapErvasInvasorasSummary__DetailsRow"
              >
                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 12 }}
                  className="VantMapErvasInvasorasSummary__DetailsColumn"
                >
                  <Row
                    gutter={[24, 24]}
                    className="VantMapErvasInvasorasSummary__ServiceTitleRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="VantMapErvasInvasorasSummary__ServiceTitleCol"
                    >
                      <Typography.Title
                        level={1}
                        className="VantMapErvasInvasorasSummary__ServiceFullTitle"
                      >
                        <span className="VantMapErvasInvasorasSummary__ServiceTitle">{'Vant: '}</span>
                        <span className="VantMapErvasInvasorasSummary__ServicesTypeTitle">Mapeamento de Ervas Invasoras</span>
                      </Typography.Title>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="VantMapErvasInvasorasSummary__DetailRow VantMapErvasInvasorasSummary__MatriculaRow"
                  >
                    <Col
                      className="VantMapErvasInvasorasSummary__DetailColumn VantMapErvasInvasorasSummary__MatriculaColumn"
                      xs={{ span: 24 }}
                    >
                      {`Matrícula: ${serviceRequestParameters.selectedProperty.matriculation}`}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="VantMapErvasInvasorasSummary__DetailRow VantMapErvasInvasorasSummary__CooperadoRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="VantMapErvasInvasorasSummary__DetailColumn VantMapErvasInvasorasSummary__CooperadoColumn"
                    >
                      {`Cooperado: ${serviceRequestParameters.selectedOwner.name}`}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="VantMapErvasInvasorasSummary__DetailRow VantMapErvasInvasorasSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="VantMapErvasInvasorasSummary__DetailColumn VantMapErvasInvasorasSummary__PropriedadeColumn"
                    >
                      {`Propriedade: ${serviceRequestParameters.selectedProperty.name}`}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="VantMapErvasInvasorasSummary__DetailRow VantMapErvasInvasorasSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="VantMapErvasInvasorasSummary__DetailColumn VantMapErvasInvasorasSummary__PropriedadeColumn"
                    >
                      {
                        userMailCooperative()
                      }
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="VantMapErvasInvasorasSummary__DetailRow VantMapErvasInvasorasSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="VantMapErvasInvasorasSummary__DetailColumn VantMapErvasInvasorasSummary__PropriedadeColumn"
                    >
                      <span>{`Possui CTC: ${serviceRequestParameters.haveCtc ? 'Sim' : 'Não'}`}</span>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="VantMapErvasInvasorasSummary__DetailRow VantMapErvasInvasorasSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="VantMapErvasInvasorasSummary__DetailColumn VantMapErvasInvasorasSummary__PropriedadeColumn"
                    >
                      <span>{`CTC: : ${serviceRequestParameters.ctc ? serviceRequestParameters.ctc : '-'}`}</span>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="VantMapErvasInvasorasSummary__DetailRow VantMapErvasInvasorasSummary__PropriedadeRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="VantMapErvasInvasorasSummary__DetailColumn VantMapErvasInvasorasSummary__PropriedadeColumn"
                    >
                      <span>{`Filial: ${serviceRequestParameters.branchName ? serviceRequestParameters.branchName : '-'}`}</span>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="VantMapeamentoErvasInvasorasSummary__DetailRow VantMapeamentoErvasInvasorasSummary__FieldsRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="VantMapeamentoErvasInvasorasSummary__DetailColumn VantMapeamentoErvasInvasorasSummary__FieldsColumn"
                    >
                      {renderField('VANT-MAPEAMENTO_ERVAS-INVASORAS-INSERIR_ALTURA_CULTURA')}
                      {renderField('VANT-MAPEAMENTO_ERVAS-INVASORAS-PULVERIZACAO')}
                      {renderField('VANT-MAPEAMENTO_ERVAS-INVASORAS-SUBSOLAGEM')}
                      {renderField('VANT-MAPEAMENTO_ERVAS-INVASORAS-GRADAGEM')}
                      {renderField('VANT-MAPEAMENTO_ERVAS-INVASORAS-CULTURA_SECUNDARIA')}
                      {renderField('VANT-MAPEAMENTO_ERVAS-INVASORAS-CULTURA_TERCEARIA')}
                      {renderField('VANT-MAPEAMENTO_ERVAS-INVASORAS-AUTOMATIZACAO_MANOBRA_PLANTIO')}
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="VantMapErvasInvasorasSummary__PhoneRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="VantMapErvasInvasorasSummary__PhoneColumn"
                    >
                      <Typography.Title
                        level={4}
                        className="VantMapErvasInvasorasSummary__PhoneTitle"
                      >
                        Telefone para contato
                      </Typography.Title>
                      <Form.Item
                        name="TelInput"
                        className="VantMapErvasInvasorasSummary__PhoneFormItem"
                        validateTrigger={['onBlur']}
                        rules={[
                          {
                            required: true,
                            message: 'Por favor, insira um telefone.',
                          },
                          {
                            min: 14,
                            message: 'Telefone inválido',
                          },
                        ]}
                      >
                        <MaskedInput
                          guide={false}
                          mask={mask}
                          placeholder="Telefone"
                          className="ant-input VantMapErvasInvasorasSummary__PhoneMaskedInput"
                          maxLength={15}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="VantMapErvasInvasorasSummary__CommentsRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="VantMapErvasInvasorasSummary__CommentsColumn"
                    >
                      <Typography.Title
                        level={4}
                        className="VantMapErvasInvasorasSummary__CommentsTitle"
                      >
                        Observação
                      </Typography.Title>
                      <Form.Item
                        className="VantMapErvasInvasorasSummary__CommentsFormItem"
                        name="observacao"
                        rules={[
                          {
                            max: 1000,
                            message: 'A observação deve ter no máximo 1000 caractéres',
                          },
                        ]}
                      >
                        <Input.TextArea
                          className="obsArea VantMapErvasInvasorasSummary__CommentsInput"
                          xs={{ span: 24 }}
                          lg={{ span: 10 }}
                          rows={4}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row
                    gutter={[8, 8]}
                    className="VantMapErvasInvasorasSummary__AttachmentsRow"
                  >
                    <Col
                      xs={{ span: 24 }}
                      className="VantMapErvasInvasorasSummary__AttachmentsColumn"
                    >
                      <Typography.Title
                        level={4}
                        className="VantMapErvasInvasorasSummary__AttachmentsTitle"
                      >
                        Anexos do cooperado
                      </Typography.Title>
                      <Form.Item
                        name="anexo"
                        className="VantMapErvasInvasorasSummary__AttachmentsFormItem"
                      >
                        <div className="attachments-items-container">
                          <UploadFiles
                            ref={uploadFilesReference}
                            origin="summary"
                            requestType={
                              isItEstimateOrService(
                                serviceRequestParameters.choiceServiceType === 1 ? 'ORCAMENTO' : 'SERVICO',
                                getUserType(),
                              )
                            }
                            typeUser="SERVICE_REQUEST_CUSTOMER_FILE"
                            action="edit"
                            id={requestId}
                            fileSize={valueAttachmentSizeCooperated}
                            initialFiles={
                              [].map((item) => ({ ...item, uid: item.id, status: 'done' }))
                            }
                          />
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 12 }}
                  className="VantMapErvasInvasorasSummary__GeomapColumn"
                >
                  <SelectedLands
                    talhoesSelecionados={serviceRequestParameters.talhoesSelecionados}
                    removeSelectedField={removeSelectedField}
                  />

                  <div
                    className="VantMapErvasInvasorasSummary__AreaTalhaoSpacing"
                  >
                  </div>

                  <AreaTalhao
                    talhoesSelecionados={serviceRequestParameters.talhoesSelecionados}
                  />

                  <GeoMapSummary
                    params={serviceRequestParameters}
                  />
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
                justify="end"
                className="VantMapErvasInvasorasSummary__ButtonRow"
              >
                <Col
                  xs={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                  className="VantMapErvasInvasorasSummary__ButtonFirstColumn"
                >
                  <Button
                    block
                    className="VantMapErvasInvasorasSummary__BackButton"
                    onClick={() => previousPage()}
                    loading={loading}
                  >
                    <ArrowLeftIcon className="VantMapErvasInvasorasSummary__ArrowLeftIcon" />
                    Voltar
                  </Button>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                  className="VantMapErvasInvasorasSummary__ButtonSecondColumn"
                >
                  <Form.Item
                    className="VantMapErvasInvasorasSummary__ContinueButtonFormItem"
                  >
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      className="VantMapErvasInvasorasSummary__ContinueButton"
                      loading={loading}
                    >
                      Confirmar Solicitação
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Summary.propTypes = {
  removeSelectedField: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,

  serviceRequestParameters: PropTypes.shape({
    selectedSubType: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),

    haveCtc: PropTypes.bool,
    ctc: PropTypes.string,
    branchCoopercitrusId: PropTypes.number,
    choiceServiceType: PropTypes.number,
    branchName: PropTypes.string,

    serviceTypeDynamicFields: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        idCode: PropTypes.string,
      }),
    ).isRequired,

    serviceSubtypeDynamicFields: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        idCode: PropTypes.string,
      }),
    ).isRequired,

    service: PropTypes.string,

    serviceRequestFieldInputList: PropTypes.arrayOf(
      PropTypes.shape({
        idCode: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
          PropTypes.instanceOf(moment),
          PropTypes.bool,
        ]),
      }),
    ),

    selectedProperty: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
      registeredOn: PropTypes.instanceOf(moment),
      matriculation: PropTypes.string,

      location: PropTypes.shape({
        lat: PropTypes.number,
        lon: PropTypes.number,
      }),
    }),

    selectedType: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),

    selectedService: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),

    selectedOwner: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
    }),

    talhoesSelecionados: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        area: PropTypes.number,
        culture: PropTypes.shape({}),
        details: PropTypes.string,
        landId: PropTypes.number,
        name: PropTypes.string,

        polygon: PropTypes.arrayOf(
          PropTypes.shape({
            lat: PropTypes.number,
            lon: PropTypes.number,
          }),
        ),
      }),
    ),
  }).isRequired,
};
Summary.defaultProps = {};

export default Summary;
